/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Cancel_MsgInputs */



/**
* | output |
* | --- |
* | "Cancels this round. Its seating and scores are kept, and you can restore it later. Players go back to check-in." |
*
* @param {Rounds_Cancel_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_cancel_msg = /** @type {((inputs?: Rounds_Cancel_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Cancel_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annule cette ronde. Son placement et ses scores sont conservés, et vous pourrez la restaurer. Les joueurs repassent au pointage.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anula esta ronda. Sus mesas y resultados se conservan, y podrá restaurarla. Los jugadores vuelven al check-in.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancela esta rodada. As mesas e os resultados ficam guardados, e você poderá restaurá-la. Os jogadores voltam ao check-in.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla questo round. Posti e punteggi restano, e potrai ripristinarlo. I giocatori tornano al check-in.")
	return /** @type {LocalizedString} */ ("Cancels this round. Its seating and scores are kept, and you can restore it later. Players go back to check-in.")
});